module.exports = __webpack_public_path__ + "mercury-wordmark-4b94e236fbaac38a78c0732306bb451c.webp";